import { parseFormData } from '@utils';
import axios from 'axios';

const baseUrl = process.env.NEXT_PUBLIC_ADITUS_API + '/orders';

const prepareHeaders = (access_token) => {
  const headers = {};
  const token = access_token;
  if (token) {
    headers['Accept'] = 'application/json';
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
};

export const getOrders = async (access_token) => {
  const path = `${baseUrl}/history`;
  let response = {
    data: null,
    error: false,
  };

  try {
    const headers = prepareHeaders(access_token);
    await axios
      .get(path, { headers })
      .then((res) => {
        response = { ...response, data: res.data };
      })
      .catch((error) => {
        response = { ...response, error: error };
      });
  } catch (error) {
    console.error('getOrders', error);
    return { error };
  }
  return response;
};

export const createOrder = async ({ data }, access_token) => {
  const path = `${baseUrl}`;
  let response = {
    data: null,
    error: false,
  };

  try {
    const headers = prepareHeaders(access_token);
    await axios
      .post(path, parseFormData(data), { headers })
      .then((res) => {
        response = { ...response, data: res.data };
      })
      .catch((error) => {
        response = { ...response, error: error };
      });
  } catch (error) {
    console.error('createOrder', error);
    return { error };
  }
  return response;
};
